// removed by extract-text-webpack-plugin
module.exports = {"root":"_3fRR8","overlap":"_3MekN","plain":"_2QEMQ","overlapEl":"_3opO9"};


//////////////////
// WEBPACK FOOTER
// ../source/layouts/Masthead/styles.css
// module id = 1249
// module chunks = 0 1 2 3 4 5 7 8 9 11 12 13 15 16 18